import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { RootState, setGameSrc, useAppDispatch, useAppSelector } from "@hypexone/uicore";
import { getGameUrl } from "@hypexone/uicore";
import Header from "../header/Header";
import { connect } from "react-redux";
import Loader from "../shared/Loader";

type StoreProps = {
  getGameUrl: Function;
  setGameSrc: (val: string) => void;
  gameSrc: string;
  loading: boolean;
  loggedIn: boolean;
  balance: number;
  exposure: number;
};

type RouteParams = {
  gamePath: string;
};

const CasinoIFrame: React.FC<StoreProps> = ({
  getGameUrl,
  setGameSrc,
  gameSrc,
  loading,
  loggedIn,
  balance,
  exposure,
}) => {
  const { langData } = useAppSelector((state) => state.cms);
  const { gamePath } = useParams<RouteParams>();
  const locationState: any = useLocation().state;

  const [shouldRenderIframe, setShouldRenderIframe] = useState(false);

  useEffect(() => {
    if (!gamePath) return;

    // Step 1: Unmount the iframe
    setShouldRenderIframe(false);
    setGameSrc("");

    // Step 2: After short delay, fetch the new game
    const timeout = setTimeout(() => {
      const parts = gamePath.split("-");
      const gameId = atob(parts[parts.length - 5]);
      const gameCode = atob(parts[parts.length - 4]);
      const provider = atob(parts[parts.length - 3]);
      const subProvider = atob(parts[parts.length - 2]);
      const superProvider = atob(parts[parts.length - 1]);

      if (loggedIn) {
        const gameName = locationState?.gameName;
        saveLastPlayedGameDetails({
          gameId,
          gameName,
          gameCode,
          provider,
          subProvider,
          superProvider,
        });
        getGameUrl({ gameId, gameCode, provider, subProvider, superProvider });
      }
    }, 50); // 50ms delay ensures iframe unmounts

    return () => clearTimeout(timeout);
  }, [gamePath]);

  useEffect(() => {
    // When gameSrc updates, trigger iframe rendering
    if (gameSrc) {
      setShouldRenderIframe(true);
    }
  }, [gameSrc]);

  const saveLastPlayedGameDetails = (newGame) => {
    const existingGames = JSON.parse(localStorage.getItem("recent_games")) || [];
    if (existingGames.length > 0 && existingGames[0].gameId === newGame.gameId) {
      return;
    }
    existingGames.unshift(newGame);
    const updatedGames = existingGames.slice(0, 3);
    localStorage.setItem("recent_games", JSON.stringify(updatedGames));
  };

  useEffect(() => {
    return () => {
      setGameSrc("");
    };
  }, []);

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <Header balance={balance} exposure={exposure} loggedIn={loggedIn} />
      {loading || !shouldRenderIframe ? (
        <div className="flex items-center justify-center h-full">
          <Loader />
        </div>
      ) : (
        <iframe
          key={gameSrc}
          src={gameSrc}
          className="h-full w-screen"
          title={langData?.['dc_game']}
          allowFullScreen
          sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  gameSrc: state.catalog.gameSrc,
  loggedIn: state.auth.loggedIn,
  loading: state.catalog.loading,
  balance: state.auth.balanceSummary.balance,
  exposure: state.auth.balanceSummary.exposure,
});

const mapDispatchToProps = (dispatch: Function) => ({
  getGameUrl: (event: any) => dispatch(getGameUrl(event)),
  setGameSrc: (val: string) => dispatch(setGameSrc(val)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CasinoIFrame);

